export default __webpack_public_path__ + "static/media/a017-i.5422e282.svg";